import classes from "./RightSidebar.module.css";
import { Button, Dropdown, Text } from "components/common";
import Devider2 from "components/common/Devider2/Devider";
import Switch from "components/common/Switch/Switch";
import { useState, useEffect } from "react";

const aiModels = ["GPT-4o", "Llama 3.2 3B", "DeepSeek R1671B", "Dolphin 72B"];
const tones = ["Professional", "Professional2"];
const formalityLevels = ["Casual", "Formal"];
const responseLength = ["Low", "Medium", "High"];

const ChatSettings = () => {
  // State variables
  const [showSelectAiDropdown, setShowSelectAiDropdown] = useState(false);
  const [selectedAiModel, setSelectedAiModel] = useState(
    localStorage.getItem("selectedAiModel") || "GPT-4o"
  );
  const [showTonesDropdown, setShowTonesDropdown] = useState(false);
  const [selectedTones, setSelectedTones] = useState(
    localStorage.getItem("selectedTones") || "Professional"
  );
  const [showFormalityLevelDropdown, setShowFormalityLevelDropdown] =
    useState(false);
  const [selectedFormalityLevel, setSelectedFormalityLevel] = useState(
    localStorage.getItem("selectedFormalityLevel") || "Casual"
  );
  const [showResponseLengthDropdown, setShowResponseLengthDropdown] =
    useState(false);
  const [selectedResponseLength, setSelectedResponseLength] = useState(
    localStorage.getItem("selectedResponseLength") || "Medium"
  );
  const [allowEmojiAndGifs, setAllowEmojiAndGifs] = useState(
    JSON.parse(localStorage.getItem("allowEmojiAndGifs")) || false
  );

  // Reset to default settings
  const handleReset = () => {
    setSelectedAiModel("GPT-4o");
    setSelectedTones("Professional");
    setSelectedFormalityLevel("Casual");
    setSelectedResponseLength("Medium");
    setAllowEmojiAndGifs(false);

    localStorage.setItem("selectedAiModel", "GPT-4o");
    localStorage.setItem("selectedTones", "Professional");
    localStorage.setItem("selectedFormalityLevel", "Casual");
    localStorage.setItem("selectedResponseLength", "Medium");
    localStorage.setItem("allowEmojiAndGifs", JSON.stringify(false));
  };

  // Update localStorage when any setting changes
  useEffect(() => {
    localStorage.setItem("selectedAiModel", selectedAiModel);
    localStorage.setItem("selectedTones", selectedTones);
    localStorage.setItem("selectedFormalityLevel", selectedFormalityLevel);
    localStorage.setItem("selectedResponseLength", selectedResponseLength);
    localStorage.setItem(
      "allowEmojiAndGifs",
      JSON.stringify(allowEmojiAndGifs)
    );
  }, [
    selectedAiModel,
    selectedTones,
    selectedFormalityLevel,
    selectedResponseLength,
    allowEmojiAndGifs,
  ]);

  return (
    <>
      <div className={classes.selectBox}>
        <Text primitive200 sm>
          Select AI Model
        </Text>
        <Dropdown
          className={classes.dropdown}
          items={aiModels}
          isActive={showSelectAiDropdown}
          setIsActive={setShowSelectAiDropdown}
          selectedValue={selectedAiModel}
          setSelectedAiModel={setSelectedAiModel}
          onSelect={(val) => setSelectedAiModel(val)} // Preserving the onSelect
        />
      </div>

      <div className={classes.selectBox}>
        <Text primitive200 sm>
          Tones
        </Text>
        <Dropdown
          className={classes.dropdown}
          items={tones}
          isActive={showTonesDropdown}
          setIsActive={setShowTonesDropdown}
          selectedValue={selectedTones}
          setSelectedAiModel={setSelectedTones}
          onSelect={(val) => setSelectedTones(val)} // Preserving the onSelect
        />
      </div>

      <Devider2 className={classes.devider} />

      <div className={classes.selectBox}>
        <Text primitive0 sm>
          Custom Configuration:
        </Text>
        <div className={classes.spaceBetween}>
          <Text className={classes.label}>Formality Level</Text>
          <Dropdown
            className={classes.dropdown}
            items={formalityLevels}
            isActive={showFormalityLevelDropdown}
            setIsActive={setShowFormalityLevelDropdown}
            selectedValue={selectedFormalityLevel}
            setSelectedAiModel={setSelectedFormalityLevel}
            onSelect={(val) => setSelectedFormalityLevel(val)} // Preserving the onSelect
          />
        </div>
        <div className={classes.spaceBetween}>
          <Text className={classes.label}>Response Length</Text>
          <Dropdown
            className={classes.dropdown}
            items={responseLength}
            isActive={showResponseLengthDropdown}
            setIsActive={setShowResponseLengthDropdown}
            selectedValue={selectedResponseLength}
            setSelectedAiModel={setSelectedResponseLength}
            onSelect={(val) => setSelectedResponseLength(val)} // Preserving the onSelect
          />
        </div>
        <div className={classes.spaceBetween}>
          <Text className={classes.label}>Emojis & GIFs</Text>
          <Switch
            isChecked={allowEmojiAndGifs}
            setIsChecked={setAllowEmojiAndGifs}
          />
        </div>
      </div>

      <Devider2 className={classes.devider} />

      <div className={classes.selectBox}>
        <div className={classes.spaceBetween}>
          <Text primitive0 sm>
            System Prompt:
          </Text>
          <Button sm primary>
            Add
          </Button>
        </div>
        <div className={classes.promptWrapper}>
          <Text className={classes.label} sm textCenter>
            Craft a System Prompt to dictate its responses and interactions.
          </Text>
        </div>
      </div>

      <Devider2 className={classes.devider} />

      <Button primitive800 onClick={handleReset}>
        Reset
      </Button>
    </>
  );
};

export default ChatSettings;
